// TODO: move to src/utils/core
const determineFbSalonId = () => {
  const SEPARATOR = 'state=';
  const href = window.location.href;

  if (href.indexOf(SEPARATOR) <= 0) return void 1;

  const id = href.split(SEPARATOR)[1];
  window.faceBookSalonId = id;

  return id;
};

// noinspection JSUnusedGlobalSymbols
export default determineFbSalonId;
